import { render, staticRenderFns } from "./ShoesCard.vue?vue&type=template&id=a3bef364&"
import script from "./ShoesCard.vue?vue&type=script&lang=js&"
export * from "./ShoesCard.vue?vue&type=script&lang=js&"
import style0 from "./ShoesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports